<!--
 * @Author: wangjiaxiang
 * @Date: 2022-08-20 19:20:10
 * @LastEditTime: 2022-08-30 15:24:16
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description:
 * @FilePath: /大增长星妈会C端/xmh-front-content/src/components/home/userCardSearch/index.vue
 *
-->
<template>
  <div class="usercard-search" :class="currentPath">
    <!-- 爱本首页 -->
    <template v-if="currentPath === 'aiBenHome'">
      <van-popover
        v-model="switchBabyFlag"
        :get-container="getContainer"
        :offset="[0, 18]"
        placement="bottom-start"
      >
        <div class="baby-list">
          <p class="title">我的状态</p>
          <ul class="baby-ul-list">
            <li
              class="baby-item"
              @click="gotoPage(0)"
            >
              <img src="@/assets/images/nweHome/xmh-logo.png" />
              <div class="item-right">
                <p class="item-info">
                  <span class="nice-name">星妈会首页</span>
                </p>
              </div>
            </li>
            <li
              class="baby-item"
              @click="gotoPage(1)"
            >
              <img src="@/assets/images/nweHome/aiben-icon.png" />
              <div class="item-right">
                <p class="item-info">
                  <span class="nice-name">家庭健康专家</span>
                </p>
                <img
                  src="@/assets/images/nweHome/pop-checked.png"
                  alt="选中"
                />
              </div>
            </li>
          </ul>
          <div
            v-if="babyInfo && babyInfo.length > 0"
            class="button glBaby"
            @click="glBaby"
          >
            宝宝管理
          </div>
        </div>
        <template #reference>
          <p class="current-state" @click="openBabyList">
            <span>{{
              loginFlag && !editFlag
                ? "未定制"
                : currentBabyInfo.tag_id == 1
                ? "备孕"
                : currentBabyInfo.tag_id == 2
                ? "怀孕"
                : "育儿"
            }}</span>
            <img src="@/assets/images/nweHome/aiben-arrow.png" alt="" />
          </p>
        </template>
      </van-popover>
      <p
        class="message-icon icon"
        @click="loginFlag ? toNewMseeage() : toLogin()"
      >
        <img src="@/assets/images/nweHome/aiben-message.png" alt="" />
        <span class="tips" v-if="countMessage != '0'"></span>
      </p>
    </template>
    <!-- 星妈会首页 -->
    <template v-else>
      <div class="top-icon-box">
        <div style="position: relative">
          <img
            class="icon imgScale"
            src="@/assets/images/nweHome/Signin.png"
            alt="签到"
            @click="loginFlag ? '' : toLogin()"
          />
          <openWxTag
            v-if="loginFlag"
            id="launch-btn-signin"
            path="/subPackages/xmhMainProcess/myIntegral/index?sign_source=XMHHOME&isSignIn=true"
            btnStyle="display:block;width:100%;height:30px;"
            name="图片点击"
            @sensorsFn="goSigin"
          ></openWxTag>
        </div>
        <p
          class="message-icon icon"
          @click="loginFlag ? toNewMseeage() : toLogin()"
        >
          <img src="@/assets/images/nweHome/message.png" alt="" />
          <span class="tips" v-if="countMessage != '0'"></span>
        </p>
      </div>
      <div class="xmh-home-ai-search">
        <img class="ai-head-icon" src="@/assets/images/aiTalk/ai-head-icon.png" alt="" />
        <div class="xmh-home-ai">
          <div class="xmh-home-ai-box" @click="goToAiTalk" >
            <span class="text">点击即可向小飞提问哦～</span>
            <img class="next-icon" src="@/assets/images/aiTalk/next-icon.png" alt="" />
          </div>
        </div>
        <div class="xmh-home-search">
          <van-popover
            v-model="switchBabyFlag"
            :get-container="getContainer"
            :offset="[0, 18]"
            placement="bottom-start"
          >
            <div class="baby-list">
              <p class="title">我的状态</p>
              <ul class="baby-ul-list">
                <li
                  class="baby-item"
                  v-for="babyItem in babyInfo"
                  :key="babyItem.id"
                  @click="switchBabyInfo(babyItem)"
                >
                  <img
                    v-if="babyItem.tag_id == 1"
                    src="@/assets/images/nweHome/beiyun-icon.png"
                  />
                  <img
                    v-else-if="babyItem.tag_id == 2"
                    src="@/assets/images/nweHome/huaiyun-icon.png"
                  />
                  <img
                    src="@/assets/images/home/type3.png"
                    v-else-if="babyItem.tag_id > '2' && babyItem.sex == 'M'"
                  />
                  <img
                    src="@/assets/images/home/type4.png"
                    alt=""
                    v-else-if="babyItem.tag_id > '2' && babyItem.sex == 'F'"
                  />
                  <img
                    src="@/assets/images/home/type4.png"
                    alt=""
                    v-else-if="babyItem.tag_id > '2' && babyItem.sex == 'O'"
                  />
                  <img
                    src="../../../assets/images/home/type4.png"
                    alt=""
                    v-else-if="babyItem.tag_id > '2' && babyItem.sex == ''"
                  />
                  <div class="item-right">
                    <!-- 备孕显示 -->
                    <p class="item-info" v-if="babyItem.tag_id == 1">
                      <span class="nice-name">备孕</span>
                    </p>
                    <!-- 非备孕 -->
                    <p class="item-info" v-else>
                      <span class="nice-name">{{
                        babyItem.tag_id == 2 ? "怀孕中" : babyItem.nick || "鹤小宝"
                      }}</span>
                      <span>{{
                        babyItem.num == 1 ? babyDays.firsttime : babyDays.secondtime
                      }}</span>
                    </p>
                    <img
                      v-if="
                        currentBabyInfo &&
                        currentBabyInfo.num == babyItem.num
                      "
                      src="@/assets/images/nweHome/pop-checked.png"
                      alt="选中"
                    />
                  </div>
                </li>
                <li
                  v-if="babyInfo == null || (babyInfo && babyInfo.length <= 0)"
                  class="baby-item"
                  @click="addBaby"
                >
                  <img src="@/assets/images/nweHome/edit-icon.png" />
                  <div class="item-right">
                    <p class="item-info">
                      <span class="nice-name">定制孕育状态</span>
                    </p>
                  </div>
                </li>
                <li
                  class="baby-item"
                  @click="gotoPage(1)"
                >
                  <img src="@/assets/images/nweHome/aiben-icon.png" />
                  <div class="item-right">
                    <p class="item-info">
                      <span class="nice-name">家庭健康专家</span>
                    </p>
                  </div>
                </li>
              </ul>
              <div
                v-if="babyInfo && babyInfo.length > 0"
                class="button glBaby"
                @click="glBaby"
              >
                宝宝管理
              </div>
            </div>
            <template #reference>
              <p class="current-state" @click="openBabyList">
                <span>{{
                  loginFlag && !editFlag
                    ? "未定制"
                    : currentBabyInfo.tag_id == 1
                    ? "备孕"
                    : currentBabyInfo.tag_id == 2
                    ? "怀孕"
                    : "育儿"
                }}</span>
                <img src="@/assets/images/nweHome/arrow.png" alt="" />
              </p>
            </template>
          </van-popover>
          <div class="search-input-box" @click="toSearch">
            <div class="search-input-content">
              <span class="text">请点击搜索相关育儿知识～</span>
              <img class="search-icon" src="@/assets/images/aiTalk/search-icon.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import Index from "./js/index.js";
export default Index;
</script>
<style lang="less" scoped>
@import "./less/index.less";
</style>
<style lang="less">
@import "./less/popover-content.less";
</style>
